/* ========================================================================
   ProductImage - resizes product image to desired dimentions
   ======================================================================== */
class ProductImage extends HTMLElementPlus {
  init() {
    console.assert(this.size, "size attribute not provided for <p-product-image>")
    console.assert(this.src, "src attribute not provided for <p-product-image>")
    let i = this.src.lastIndexOf(".")
    let newURL = `${this.src.substring(0, i)}_${this.size}x${this.size}${this.src.substring(i)}`
    $(this).append($("<img>").attr("src", newURL))
  }
}
customElements.define("p-product-image", ProductImage)

/* ========================================================================
   StockStatus - indicates stock availability based on required quantity
   ======================================================================== */
class StockStatus extends HTMLElementPlus {
  init() {
    // quantity changes in quantity picker
    $(`p-quantity-picker[variant='${ $(this).attr("variant") }']`).on("quantitychange", (e, quantity) => {      
      this.required = quantity
      this.update()
    })
  }

  update() {    
    $(this).removeClass()
    let required = this.required ? parseInt(this.required) : 0
    let stock = this.stock
    if(this.retired == "true") {
      this.innerHTML = "Retired"
      $(this).addClass("retired")
    }else if(stock > 0) {
      this.innerHTML = "In stock"
      $(this).addClass("in-stock")
    }else if(this.canBackorder == "true") {
      this.innerHTML = "Backorder"
      $(this).addClass("back-order")
    }else{
      this.innerHTML = "Out of stock"
      $(this).addClass("out-of-stock")
    }
  }
}
customElements.define("p-stock-status", StockStatus)

/* ========================================================================
   PriceTiers - presents an interactive list of pricing tiers
   ======================================================================== */
class PriceTiers extends HTMLElementPlus {
  init() {    
    this.buildTiers()    
  }

  getQuantityPicker() {
    return $(`p-quantity-picker[variant='${this.variant}'][group='${this.group}']`)
  }

  getTier(quantity) {
    let tiers = $(this).attr("tiers")
    if(tiers == undefined || quantity == undefined) { 
      return undefined 
    }    
    quantity = parseInt(quantity)
    const usp = new URLSearchParams(tiers)
    for(let tierQuantity of Array.from(usp.keys()).reverse()) {
      tierQuantity = parseInt(tierQuantity)
      if(quantity >= tierQuantity) {
        return {quantity: parseInt(tierQuantity), price: parseFloat(usp.get(tierQuantity))}
      }
    }
  }

  update() {
    // check against each tier in reverse to find the first match and highlight it
    $(this).children().removeClass("active")    
    const tier = this.getTier($(this).attr("quantity"))
    if(tier != undefined) {
      $(this).children(`[quantity='${ tier.quantity }']`).addClass("active")    
      $(this).trigger("tierchange", [tier.price])
    }
  }

  buildTiers() {
    // build tier list
    $(this).empty()
    let tiers = new URLSearchParams($(this).attr("tiers"))
    let rrp = parseFloat(tiers.get("1"))
    for (const [quantity, price] of tiers.entries()) {
      let tierPrice = parseFloat(price)
      let marginPercent = undefined
      if(tierPrice != rrp) {
        marginPercent = Math.round(((rrp - tierPrice) * 100) / rrp)
      }
      let tierHTML = `<div quantity='${ quantity }' price='${ price }'>
        <span>${ quantity }+</span> <span class="money">£${ parseFloat(price).toFixed(2) }</span>
        <span>${ marginPercent ? `-${ marginPercent }%` : ""}</span>
      </div>`
      this.insertAdjacentHTML("beforeend", tierHTML)
    }

    // when tier clicked sent change event
    $(this).children().click((e) => {
      $(this).trigger("quantitychange", [parseInt($(e.currentTarget).attr("quantity"))])
    })

    // quantity picker value changed
    this.getQuantityPicker().on("quantitychange", (e, quantity) => {      
      $(this).attr("quantity", quantity)
    })       

    // get initial value
    this.getQuantityPicker().each((i, e) => {
      $(this).attr("quantity", $(e).attr("quantity"))
    })
  }

  tiersChanged() {
    this.buildTiers()
  }
}
customElements.define("p-price-tiers", PriceTiers)

/* ========================================================================
   QuantityPicker - manages add to cart and quantity input functions
   ======================================================================== */
class QuantityPicker extends HTMLElementPlus {
  init() {        
    this.innerHTML = `
      <div> 
        <button class="one button">Buy</button>
        <fieldset>
          <button aria-label="Remove" title="Remove from cart" class="remove button red" tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" height="0.8rem" width="0.8rem" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>
          </button>
          <button aria-label="Decrease quantity" title="Decrease quantity by 1" class="decrease button grey" tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 13H5v-2h14v2z"/></svg>
          </button>
          <input type="text" aria-label="Set quantity" title="Enter quantity">
          <button aria-label="Increase quantity" title="Increase quantity by 1" class="increase button grey" tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          </button>
        </fieldset>
      </div>
      <small>Not available<br>for backorder</small>` 
    
    // quantity entered into input
    $(this).find("input").on("input change", (e) => {          
      this.changeQuantity(e.currentTarget.value)
    })
    $(this).find(".one").focus((e) => {
      this.update()
    })
    // decrease, increase, and add one button handlers
    $(this).find(".one").click((e) => {      
      this.changeQuantity(1)      // item added by "Buy" or "Backorder" button
      $(this).find("input").focus().select()
    })
    $(this).find(".remove").click((e) => {      
      this.changeQuantity(0) // quantity reduce button
      $(this).trigger("remove")
    })
    $(this).find(".decrease").click((e) => {      
      this.changeQuantity(parseInt(this.quantity) - 1) // quantity reduce button
    })
    $(this).find(".increase").click((e) => {            
      this.changeQuantity(parseInt(this.quantity) + 1) // quantity increase button
    })
    // tier clicked in tier list
    this.getPriceTiers().on("quantitychange", (e, quantity) => {      
      this.changeQuantity(quantity)
    })

    // set initial value to match current cart value or zero if no quantity was provided
    if(!this.quantity) {
      let matching = cart.items.find(item => item.variant_id == this.variant)
      this.changeQuantity(matching?.quantity, true)    
    }else{
      this.changeQuantity(this.quantity, true)
    }
  } 

  getPriceTiers() {
    return $(`p-price-tiers[variant='${this.variant}'][group='${this.group}']`)
  }

  changeQuantity(quantity, noChangeEvent = false) {    
    this.quantity = Math.max(parseInt(this.minQuantity || 0), parseInt(quantity || 0))
    this.update()
    $(this).find("input").val(this.quantity)
    if(!noChangeEvent) {
      $(this).trigger("quantitychange", [this.quantity])
    }
  }

  quantityChanged(quantity) {
    $(this).find("input").val(quantity)
  }

  update() {     
    // don't show/hide the "Buy" vs the up/down/input if the input is currently focussed
    if(!$(this).find("input").is(":focus")) {
      $(this).children("div").children("button").toggle(this.quantity < 1)
      $(this).children("div").children("fieldset").toggle(this.quantity >= 1)
    }

    $(this).children("div").toggle(this.quantity > 0 || this.inStock == "true" || this.canBackorder == "true")
    $(this).children("small").toggle(this.quantity == 0 && this.inStock == "false" && this.canBackorder != "true")
    $(this).children("div").children("button").text(this.inStock == "true" ? "Buy" : "Backorder")
    $(this).children("div").children("button").toggleClass("yellow", this.inStock == "false" && this.canBackorder == "true")
    $(this).children("div").children("button").toggleClass("green", this.inStock == "true")
  }    
}
customElements.define("p-quantity-picker", QuantityPicker)

/* ========================================================================
   StarRating - shows a 5-star graphics with masked fill
   ======================================================================== */
class StarRating extends HTMLElementPlus {
  init() {
    this.innerHTML = `
      <span></span>
      <svg height="0.9rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 60" xml:space="preserve">        
        <g fill="#f0f0f0"><path d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path><path transform="translate(60 0)" d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path><path transform="translate(120 0)" d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path><path transform="translate(180 0)" d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path><path transform="translate(240 0)" d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path></g>
        <g fill="var(--yellow)"><path d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path><path transform="translate(60 0)" d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path><path transform="translate(120 0)" d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path><path transform="translate(180 0)" d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path><path transform="translate(240 0)" d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3z"></path></g>
      </svg>`      
  }

  update() {
    let clipPath = `view-box polygon(0% 0%, ${this.rating / 5 * 100}% 0%, ${this.rating / 5 * 100}% 100%, 0% 100%)`
    $(this).find("g:last-of-type").attr("clip-path", clipPath)
    $(this).children("span").text(parseInt(this.count) > 0 ? this.count : "")
  }
}
customElements.define("p-rating", StarRating)